import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { dispatch as storeDispatch } from '@store';
import { actions } from '@store/modals';

/**
 * Modals controller.
 *
 * @author Ihar Kazlouski
 * @const ModalsServiceClass
 * @category Services
 * @subcategory Modals
 */
var ModalsServiceClass = /*#__PURE__*/function () {
  function ModalsServiceClass() {
    _classCallCheck(this, ModalsServiceClass);
  }

  _createClass(ModalsServiceClass, [{
    key: "open",
    value:
    /**
     * Open modal.
     *
     * @author Ihar Kazlouski
     * @param {string} modalId modalId.
     * @param {T} data modal data.
     * @return {void}
     */
    function open(modalId, data) {
      var dispatch = storeDispatch;
      var modalAction = dispatch(actions.modalInit({
        modalId: modalId,
        data: data,
        isOpen: true
      }));
      modalAction["catch"](function (error) {
        return error;
      });
      return modalAction;
    }
    /**
     * Close modal.
     *
     * @author Ihar Kazlouski
     * @param {string} modalId modalId.
     * @param {Dispatch} dispatch dispatch.
     * @return {void}
     */

  }, {
    key: "close",
    value: function close(modalId) {
      storeDispatch(actions.modalInitClosing({
        modalId: modalId
      }));
    }
    /**
     * Close all modals.
     *
     * @author Ihar Kazlouski
     * @param {Dispatch} dispatch dispatch.
     * @return {void}
     */

  }, {
    key: "closeAllModals",
    value: function closeAllModals() {
      storeDispatch(actions.modalInitCloseAll());
    }
    /**
     * Close modal with answer.
     *
     * @author Ihar Kazlouski
     * @param {string} modalId modalId.
     * @param {Dispatch} dispatch dispatch.
     * @param {object} answer answer.
     * @return {void}
     */

  }, {
    key: "closeWithAnswer",
    value: function closeWithAnswer(modalId, _ref) {
      var _ref$accepted = _ref.accepted,
          accepted = _ref$accepted === void 0 ? false : _ref$accepted,
          _ref$rejected = _ref.rejected,
          rejected = _ref$rejected === void 0 ? false : _ref$rejected;
      storeDispatch(actions.modalInitClosingWithAnswer({
        modalId: modalId,
        accepted: accepted,
        rejected: rejected
      }));
    }
  }]);

  return ModalsServiceClass;
}();

var ModalsService = new ModalsServiceClass();
export { ModalsService };